import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { buildCoachPendingHref } from "@/lib/coachPendingAction";

export const CoachPendingActionNotice = ({
  primary,
  testId = "coach-pending-action-notice",
  compact = false,
}) => {
  if (!primary) {
    return null;
  }

  const href = buildCoachPendingHref(primary);

  return (
    <div
      role="status"
      data-testid={testId}
      data-pending-kind={primary.kind}
      className={
        compact
          ? "app-card border-brand-primary/40 bg-brand-primary/5 p-4"
          : "app-card border-brand-primary/40 bg-brand-primary/5 p-4 sm:p-5"
      }
    >
      <p className="text-[11px] uppercase tracking-[0.2em] text-brand-primary">
        Apex Coach
      </p>
      <p className="mt-2 text-sm font-medium text-dark-text-primary">
        {primary.headline}
      </p>
      {primary.message && (
        <p className="mt-1 text-sm text-dark-text-secondary">
          {primary.message}
        </p>
      )}
      <div className="mt-4">
        <Button
          asChild
          size="sm"
          className="btn-primary-app"
          data-testid={`${testId}-cta`}
        >
          <Link to={href}>{primary.actionLabel}</Link>
        </Button>
      </div>
    </div>
  );
};
